// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1Ypfr","choiceBoxes":"toolbarselects_choiceBoxes__2BZmo","simpleField":"toolbarselects_simpleField__2n8lN"};